<template>
  <div>
    <div class="ir-sub-menu">
      <ul class="col3">
        <li>
          <a href="/ir/governance">コーポレート・ガバナンス</a>
        </li>
        <li>
          <a href="/ir/business" class="selected">事業内容</a>
        </li>
        <li>
          <a href="/ir/disclosure_policy">
            ディスクロージャー
            <br class="sp" />ポリシー
          </a>
        </li>
      </ul>
    </div>

    <section>
      <div class="l-service">
        <div class="l-service-header">
          <h2 class="heading-default heading-default-center">事業内容</h2>
          <h3 class="heading-small heading-small-center heading-small-mt-sp">
            OUR BUSINESS
          </h3>

          <div class="l-service-content-inner">
            <p class="sentence sentence-mt sentence-ir-mb">
              当社グループは、当社と当社の連結子会社3社（Tabikobo Vietnam Co. Ltd.及びPT. Ramayana Tabikobo Travel）の計4社によって構成されています。<br />
              当社グループは、主に日本国内の個人顧客をターゲットにオンラインでのパッケージ旅行の企画・販売や、航空券の販売、宿泊手配、オプショナルツアーの手配等を行っております。また、個人向け以外にも、企業や官公庁、学校法人等の法人顧客向けに業務渡航や団体旅行の手配等を行っております。<br />
              連結子会社のTabikobo Vietnam Co. Ltd.は、ベトナムにおいて主に現地企業向けのコンサルティング事業を行っており、PT. Ramayana Tabikobo Travelは、インドネシアで主に個人顧客向けの宿泊及びオプショナルツアーの手配等を行っております。<br />
              当社グループの主要な事業についてその特徴を記載します。
            </p>

            <h2 class="heading-coating heading-coating-small">個人旅行事業</h2>
            <p class="sentence sentence-ir-mb">
              個人のお客様に対し、パッケージ旅行を企画・販売するとともに、単品での航空券販売、宿泊手配、オプショナルツアー、旅行保険等の手配を行っています。<br />
              個人旅行事業における当社の特徴は以下のとおりです。
            </p>

            <h3 class="mission-panel-title">インターネットでの顧客獲得</h3>
            <p class="sentence">
              当社グループでは、パッケージ旅行等の旅行関連商品の販売チャネルを自社ホームページや他社が運営する旅行系のポータルサイトといったインターネット上での販売に絞り込むとともに、お客様とのやり取りについてはメール及び電話を主な手段としています。これによって、店舗開設・運営にかかる固定費を削減し、コストの低減を図っております。
            </p>
            <p class="ir_img">
              <img src="img/business_img01.jpg" width height alt />
            </p>

            <h3 class="mission-panel-title">
              「トラベル・コンシェルジュ」による旅行カスタマイズ
            </h3>
            <p class="sentence">
              当社グループではインターネット上で顧客獲得を行っておりますが、旅行商品の販売手段としては、&#9312;個人のお客様の旅行予約に際し「トラベル・コンシェルジュ」がサポートする仕組みと、&#9313;自動化された販売システムを使用してお客様ご自身の操作によりウェブサイト上で予約手続きが完結するオンライン販売システムの2種類があります。
              <br />当社グループでは、独自に実施したインターネットユーザーの行動調査により、オンライン予約の過程で多数のユーザーが「商品ページに記載されているよりも詳細な情報を知りたい」「初めての旅行先は相談して最終決定したい」「複雑な旅程や条件で予約したい」等、システムによるオンライン予約だけでは対応できない潜在ニーズがあることを把握しております。
              <br />これらの潜在ニーズに応えるため、当社グループではシステムによるオンライン予約と、システムで対応しきれないお客様に対して、方面別に旅行先の情報に精通したプロフェッショナルによる電話やメールでの対応を組み合わせた「ハイブリッド戦略」を推し進めています。
              <br />具体的には、旅行先の方面別に「トラベル・コンシェルジュ」と呼ぶ担当者を配置し、お客様からインターネットでいただいたお問い合わせをもとに、担当する地域に精通した「トラベル・コンシェルジュ」が電話及びメールでご要望のヒアリングを行い、ヒアリング内容をもとに必要に応じて旅行内容のカスタマイズや旅程の組み直しを行って、一人ひとりのお客様に最適な旅行を提供するための体制を整えております。
              <br />これにより、自宅に居ながらにして旅行予約ができるオンラインの利便性を確保しつつ、こだわりのあるお客様のニーズにも応えられる付加価値の高い商品提案を行っております。
            </p>
            <p class="ir_img">
              <img src="img/business_img02.jpg" width height alt />
            </p>

            <h3 class="mission-panel-title">
              24時間対応のオンライン予約システム
            </h3>
            <p class="sentence sentence-ir-mb">
              当社グループは、「トラベル・コンシェルジュ」がお客様のご予約をサポートする仕組みに加えて、旅行業界の中で急成長している分野である24時間対応のオンライン予約を強化しており、お客様が航空券とホテルの組み合わせをシステム上で自由に選べるダイナミックパッケージと従来型の既製旅行パッケージを販売しております。
              <br />オンライン販売システムを利用する場合、24時間いつでも旅行商品の予約が可能となっており、曜日や時間を問わず今すぐ予約したいというお客様のニーズに対応しております。
            </p>

            <h3 class="mission-panel-title">
              方面別組織による付加価値の高い旅行商品の提供
            </h3>
            <p class="sentence sentence-ir-mb">
              当社では、アジア、アメリカ、ヨーロッパ等の方面別に組織を分けており、それぞれの部署が旅行の企画から予約、手配までを一貫して行う体制としております。目的地の地域ごとにお客様のニーズが異なることから、地域特性に応じた商品の企画及び販売を可能とすることで、価格競争力のみならずお客様のニーズに即した付加価値の高い旅行商品を提供しております。
            </p>

            <h2 class="heading-coating heading-coating-small">法人旅行事業</h2>
            <p class="sentence sentence-ir-mb">
              企業、官公庁、学校法人等のお客様に対し、国内及び海外への業務渡航手配を行っています。また、法人のお客様向けの団体旅行も取扱っており、少人数のグループ旅行から数百人規模の大型の旅行まで、研修旅行、報奨旅行はもちろんのこと、専門性の要求される国際会議、展示会、学会やコンサート等の各種イベント向けの旅行についても取扱っております。
            </p>

            <h2 class="heading-coating heading-coating-small">
              インバウンド旅行事業
            </h2>
            <p class="sentence sentence-ir-mb">
              海外から日本を訪れる訪日外国人を対象としたインバウンド旅行の手配を行っています。現在は、海外の企業や団体等による業務渡航や団体旅行への対応が中心となっておりますが、今後は国内の宿泊施設等とのネットワークを充実させて、個人による訪日旅行についても注力してまいります。
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "事業内容",
      titleTemplate: "事業内容 | 経営方針 | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
